export function formatDate(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("es-MX", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "—";
  }
}

export function formatDateTime(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("es-MX", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export const SUCURSAL_STATUS = {
  active: "Activa",
  inactive: "Inactiva",
};

export const CLIENTE_STATUS = {
  active: "Activo",
  inactive: "Inactivo",
  suspended: "Suspendido",
};

export const PAYMENT_STATUS = {
  paid: "Pagado",
  pending: "Pendiente",
  overdue: "Atrasado",
  cancelled: "Cancelado",
};

export function paymentTone(status) {
  if (status === "paid") return "success";
  if (status === "pending") return "warning";
  if (status === "overdue") return "suspended";
  if (status === "cancelled") return "inactive";
  return "neutral";
}

export function formatMoneda(value, currency = "MXN") {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  const c = currency || "MXN";
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: c,
    maximumFractionDigits: 2,
  }).format(n);
}

export const CONEXION_STATUS = {
  active: "Conexión activa",
  inactive: "Conexión inactiva",
};

export function conexionTone(status) {
  if (status === "active") return "success";
  if (status === "inactive") return "inactive";
  return "neutral";
}

export function statusTone(status) {
  if (status === "active") return "active";
  if (status === "inactive") return "inactive";
  if (status === "suspended") return "suspended";
  return "neutral";
}